<template>
  <div>
    <!-- Page Content -->
    <div class="content">
      <!-- Full Table -->
      <base-block rounded title="Topic List">
       
        <div style="display:flex;overflow-x: auto;">
          <!-- First level -->
          <div class="level1" style="display: inline-block;min-width:450px;margin:0px 5px">
            <!-- add button - parent topic -->
            <b-list-group v-if="$store.getters.userDetails.includes('CAN_ADD_TOPIC')">
              Parent Topics
              <b-list-group-item
                id="addParentTopicButton"
                v-b-modal.modal-1
                class="mb-1"
                button
                >+ Add Parent Topic</b-list-group-item
              ></b-list-group
            >

            <div style="max-height: 280px; overflow-y: scroll">
              <!-- list - parent topic -->
              <b-list-group
                v-for="(parentTopic, index) in parentTopics"
                :key="index"
              >
                <b-list-group-item class="mb-1"
                  >{{ parentTopic.name }} ({{ parentTopic.subchild_count}})
                  
                  <b-btn-group class="float-right">

                    <b-button v-if="$store.getters.userDetails.includes('CAN_EDIT_TOPIC')"
                      size="sm"
                      variant="alt-primary"
                      v-b-modal.modal-4
                      @click="loadParentTopic(parentTopic.id)"
                    >
                      <i class="fa fa-fw fa-pencil-alt"></i>
                    </b-button>

                    <b-button
                      size="sm"
                      variant="alt-primary"
                      @click="getTopics(parentTopic.id, parentTopic.name)"
                    >
                      <i class="fa fa-fw fa-angle-right"></i>
                    </b-button>
                  </b-btn-group> 

                     <!-- <b-button
                     class="float-right mr-1"
                      size="sm"
                      :variant="parentTopic.is_free ? 'success' : 'danger'"
                      @click="paidStatus(parentTopic.id, index, parentTopic.is_free)"
                    >
                      <i :class="
                        parentTopic.is_free
                          ? 'fas fa-lock-open'
                          : 'fas fa-lock'"
                          >
                     </i>
                    </b-button> -->

                    <b-button v-if="$store.getters.userDetails.includes('CAN_STATUS_TOPIC')"
                    class="float-right mr-1"
                      size="sm"
                      :variant="parentTopic.status ? 'success' : 'danger'"
                      @click="toggleStatusParentTopic(parentTopic.id, index, parentTopic.status)"
                    >
                      <i :class="
                        parentTopic.status
                          ? 'fa fa-fw fa-check'
                          : 'fa fa-fw fa-times'
                      "></i>
                    </b-button>
                  
                  </b-list-group-item
              ></b-list-group>
            </div>
            <br />
            <!-- add parent topic modal-->
            <b-modal
              id="modal-1"
              title="Add Parent Topic"
              size="lg"
              ref="modalone"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              hide-footer
            >
              <div>
                Parent Topic
                <input
                  class="col-md-6 form-control"
                  @focus="parentTopicEmpty = false"
                  v-model="parentTopicName"
                />
                <div
                  class="form-group"
                  style="color: red"
                  v-if="parentTopicEmpty"
                >
                  Parent Topic is required
                </div>
              </div>
              <div>
                <b-button
                  @click="addParentTopic()"
                  variant="success"
                  class="float-right ml-2"
                  >Insert</b-button
                >
                <b-button
                  @click="cancelButtonParentTopic()"
                  variant="danger"
                  class="float-right"
                  >Cancel</b-button
                >
              </div>
            </b-modal>

            <!-- edit parent topic modal -->
            <b-modal
              id="modal-4"
              title="Edit Parent Topic"
              size="lg"
              ref="modalfour"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              hide-footer
            >
              <div>
                Parent Topic
                <input
                  class="col-md-6 form-control"
                  @focus="parentTopicEmpty = false"
                  v-model="parentTopicName"
                />
                <div
                  class="form-group"
                  style="color: red"
                  v-if="parentTopicEmpty"
                >
                  Parent Topic is required
                </div>
              </div>
              <div>
                <b-button
                  @click="editParentTopic()"
                  variant="success"
                  class="float-right ml-2"
                  >Insert</b-button
                >
                <b-button
                  @click="cancelButtonEditParentTopic()"
                  variant="danger"
                  class="float-right"
                  >Cancel</b-button
                >
              </div>
            </b-modal>
          </div>

          <!-- second level -->
          <div class="level2" style="display: inline-block;min-width:450px;margin:0px 5px">
            <b-list-group v-if="addTopicButton && $store.getters.userDetails.includes('CAN_ADD_TOPIC')">
              Topics
              <b-list-group-item
                id="addTopicButton"
                class="mb-1"
                v-b-modal.modal-2
                button
                >+ Add Topic</b-list-group-item
              ></b-list-group
            >
            <!-- topic list -->
            <div style="max-height: 280px; overflow-y: scroll">
              <b-list-group v-for="(topic, index) in topics" :key="index">
                <b-list-group-item class="mb-1"
                  >{{ topic.name }} ({{ topic.subchild_count}})
                  <b-btn-group class="float-right">
                    
                    <b-button v-if="$store.getters.userDetails.includes('CAN_EDIT_TOPIC')"
                      size="sm"
                      variant="alt-primary"
                      @click="loadTopic(topic.id)"
                      v-b-modal.modal-5
                    >
                      <i class="fa fa-fw fa-pencil-alt"></i>
                    </b-button>

                    <b-button
                      size="sm"
                      variant="alt-primary"
                      @click="getSubtopic(topic.id, topic.name)"
                    >
                      <i class="fa fa-fw fa-angle-right"></i>
                    </b-button>
                  </b-btn-group> 

                  <b-button v-if="$store.getters.userDetails.includes('CAN_STATUS_TOPIC')"
                    class="float-right mr-1"
                      size="sm"
                      :variant="topic.status ? 'success' : 'danger'"
                      @click="toggleStatusTopic(topic.id, index, topic.status)"
                    >
                      <i :class="
                        topic.status
                          ? 'fa fa-fw fa-check'
                          : 'fa fa-fw fa-times'
                      "></i>
                    </b-button>

                  </b-list-group-item
              ></b-list-group>
            </div>

            <!-- add topic modal -->
            <b-modal
              id="modal-2"
              title="Add Topic"
              size="lg"
              ref="modaltwo"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              hide-footer
            >
              <div class="row">
                <div class="col-md-6 form-group">
                  Topic
                  <input
                    class="form-control"
                    v-model="topicName"
                    @focus="topicEmpty = false"
                  />
                  <div class="form-group" style="color: red" v-if="topicEmpty">
                    Topic is required
                  </div>
                </div>

                <div class="col-md-6 form-group">
                  Description
                  <input
                    class="form-control"
                    v-model="topicDescription"
                    @focus="topicDescriptionEmpty = false"
                  />
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="topicDescriptionEmpty"
                  >
                    Topic Description is required
                  </div>
                </div>

                <div class="col-md-6 form-group">
                  Image
                  <b-form-file
                    class="form-control"
                    @change="imageUpload"
                  ></b-form-file>
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="topicImageEmpty"
                  >
                    Topic Image is required
                  </div>
                </div>
              </div>
              <div>
                <b-button
                  @click="addTopic()"
                  variant="success"
                  class="float-right ml-2"
                  >Insert</b-button
                >
                <b-button
                  variant="danger"
                  class="float-right"
                  @click="addTopicCancelButton()"
                  >Cancel</b-button
                >
              </div>
            </b-modal>

            <!-- edit topic modal -->
            <b-modal
              id="modal-5"
              title="Edit Topic"
              size="lg"
              ref="modalfive"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              hide-footer
            >
              <div class="row">
                <div class="col-md-6 form-group">
                  Topic
                  <input
                    class="form-control"
                    v-model="topicName"
                    @focus="topicEmpty = false"
                  />
                  <div class="form-group" style="color: red" v-if="topicEmpty">
                    Topic is required
                  </div>
                </div>

                <div class="col-md-6 form-group">
                  Description
                  <input
                    class="form-control"
                    v-model="topicDescription"
                    @focus="topicDescriptionEmpty = false"
                  />
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="topicDescriptionEmpty"
                  >
                    Topic Description is required
                  </div>
                </div>

                <div class="col-md-6 form-group">
                  Image
                  <b-form-file
                    class="form-control"
                    @change="imageUpload"
                  ></b-form-file>
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="topicImageEmpty"
                  >
                    Topic Image is required
                  </div>
                </div>
              </div>
              <div>
                <b-button
                  @click="editTopic()"
                  variant="success"
                  class="float-right ml-2"
                  >Insert</b-button
                >
                <b-button
                  variant="danger"
                  class="float-right"
                  @click="cancelButtonEditTopic()"
                  >Cancel</b-button
                >
              </div>
            </b-modal>
          </div>

          <!-- third level -->
          <div class="level3" style="display: inline-block;min-width:450px;margin:0px 5px">
            <div v-if="parentTopicClicked">
            <b-list-group v-if="addSubtopicButton && $store.getters.userDetails.includes('CAN_ADD_TOPIC')">
              Subtopics
              <b-list-group-item
                id="addSubTopicButton"
                class="mb-1"
                v-b-modal.modal-3
                button
                >+ Add Subtopic</b-list-group-item
              ></b-list-group
            >

            <div style="max-height: 280px; overflow-y: scroll">
              <b-list-group v-for="(subTopic, index) in subTopics" :key="index">
                <b-list-group-item class="mb-1">
                  {{ subTopic.name }}
                  <b-button-group class="float-right">
                    <!-- <b-button
                      size="sm"
                      variant="alt-primary"
                      @click="deleteSubtopic(subTopic.id)"
                    >
                      <i class="fa fa-fw fa-trash"></i>
                    </b-button> -->
                    <b-button v-if="$store.getters.userDetails.includes('CAN_EDIT_TOPIC')"
                      size="sm"
                      variant="alt-primary"
                      @click="loadSubtopic(subTopic.id)"
                      v-b-modal.modal-6
                    >
                      <i class="fa fa-fw fa-pencil-alt"></i>
                    </b-button>
                  </b-button-group>

                  <b-button  v-if="$store.getters.userDetails.includes('CAN_STATUS_TOPIC')"
                    class="float-right mr-1"
                      size="sm"
                      :variant="subTopic.status ? 'success' : 'danger'"
                      @click="toggleStatusSubtopic(subTopic.id, index, subTopic.status)"
                    >
                      <i :class="
                        subTopic.status
                          ? 'fa fa-fw fa-check'
                          : 'fa fa-fw fa-times'
                      "></i>
                    </b-button>

                   </b-list-group-item
              ></b-list-group>
            </div>
            </div>
            <!-- add subtopic -->
            <b-modal
              id="modal-3"
              title="Add Subtopic"
              size="lg"
              ref="modalthree"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              hide-footer
            >
              <div class="row">
                <div class="col-md-6 form-group">
                  Subtopic
                  <input
                    class="form-control"
                    v-model="subtopicName"
                    @focus="topicEmpty = false"
                  />
                  <div class="form-group" style="color: red" v-if="topicEmpty">
                    Subtopic is required
                  </div>
                </div>

                <div class="col-md-6 form-group">
                  Description
                  <input
                    class="form-control"
                    v-model="subtopicDescription"
                    @focus="topicDescriptionEmpty = false"
                  />
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="topicDescriptionEmpty"
                  >
                    Subtopic Description is required
                  </div>
                </div>

                <div class="col-md-6 form-group">
                  Image
                  <b-form-file
                    class="form-control"
                    @change="subtopicImageUpload"
                  ></b-form-file>
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="subtopicImageEmpty"
                  >
                    Subtopic Image is required
                  </div>
                </div>
              </div>
              <div>
                <b-button
                  variant="success"
                  class="float-right ml-2"
                  @click="addSubTopic()"
                  >Insert</b-button
                >
                <b-button
                  variant="danger"
                  class="float-right"
                  @click="cancelButtonSubtopic()"
                  >Cancel</b-button
                >
              </div>
            </b-modal>

            <!-- edit subtopic modal -->
            <b-modal
              id="modal-6"
              title="Edit Subtopic"
              size="lg"
              ref="modalsix"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              hide-footer
            >
              <div class="row">
                <div class="col-md-6 form-group">
                  Subtopic
                  <input
                    class="form-control"
                    v-model="subtopicName"
                    @focus="topicEmpty = false"
                  />
                  <div class="form-group" style="color: red" v-if="topicEmpty">
                    Subtopic is required
                  </div>
                </div>

                <div class="col-md-6 form-group">
                  Description
                  <input
                    class="form-control"
                    v-model="subtopicDescription"
                    @focus="topicDescriptionEmpty = false"
                  />
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="topicDescriptionEmpty"
                  >
                    Subtopic Description is required
                  </div>
                </div>

                <div class="col-md-6 form-group">
                  Image
                  <b-form-file
                    class="form-control"
                    @change="subtopicImageUpload"
                  ></b-form-file>
                  <div
                    class="form-group"
                    style="color: red"
                    v-if="subtopicImageEmpty"
                  >
                    Subtopic Image is required
                  </div>
                </div>
              </div>
              <div>
                <b-button
                  variant="success"
                  class="float-right ml-2"
                  @click="editSubtopic()"
                  >Insert</b-button
                >
                <b-button
                  variant="danger"
                  class="float-right"
                  @click="cancelButtonEditSubtopic()"
                  >Cancel</b-button
                >
              </div>
            </b-modal>
          </div>
        </div>
         
         <!-- Loader -->
        <b-overlay :show="loader" no-wrap blur="2px" opacity="0.60" class="position-fixed">
          <template #overlay>
            <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
          </template>
        </b-overlay>
        <!-- End Loader -->
        
      </base-block>
      <!-- END Full Table -->
    </div>
    <!-- END Page Content -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
       loader: false,
      subtopicImageEmpty: false,
      parentTopicClicked: false,
      subtopicHeader: "",
      topicHeader: "",
      subtopicId: "",
      subtopicImage: "",
      subtopicDescription: "",
      subtopicName: "",
      topicId: "",
      addSubtopicButton: false,
      addTopicButton: false,
      topicName: "",
      topicEmpty: false,
      topicDescription: "",
      topicDescriptionEmpty: false,
      topicImage: "",
      topicImageEmpty: "",
      parentTopicId: "",
      parentTopicName: "",
      parentTopicEmpty: false,
      parentTopics: [],
      topics: [],
      subTopics: [],
    };
  },
  mounted() {
    this.getParentTopics();
  },
  methods: {
    async toggleStatusTopic(id, index, status) {
      await axios
        .get(`${this.$store.getters.baseUrl}/topic/status/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.topics[index].status = status == 1 ? 0 : 1
           this.$swal("Success", "Topic status changed successfully", "success");
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal(
            "Error",
            error.response.data.message,
            "error"
          );
        });
    },

    async toggleStatusSubtopic(id, index, status) {
      await axios
        .get(`${this.$store.getters.baseUrl}/topic/status/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.subTopics[index].status = status == 1 ? 0 : 1
           this.$swal("Success", "Subtopic status changed successfully", "success");
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal(
            "Error",
            error.response.data.message,
            "error"
          );
        });
    },

    async toggleStatusParentTopic(id, index, status) {
      await axios
        .get(`${this.$store.getters.baseUrl}/topic/status/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.parentTopics[index].status = status == 1 ? 0 : 1
           this.$swal("Success", "Parent topic status changed successfully", "success");
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal(
            "Error",
            error.response.data.message,
            "error"
          );
        });
    },

    async paidStatus(id, index, is_free) {
      await axios
        .get(`${this.$store.getters.baseUrl}/topic/statusfree/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.parentTopics[index].is_free = is_free == 1 ? 0 : 1
           this.$swal("Success", "Parent topic free status changed successfully", "success");
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal(
            "Error",
            error.response.data.message,
            "error"
          );
        });
    },
    async editSubtopic() {
      console.log(this.subtopicImage);
      if (this.subtopicName == "") {
        this.topicEmpty = true;
        return;
      }

      if (this.subtopicDescription == "") {
        this.topicDescriptionEmpty = true;
        return;
      }

      if (this.subtopicImage == "") {
        this.subtopicImageEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("name", this.subtopicName);
      formdata.append("description", this.subtopicDescription);
      formdata.append("image", this.subtopicImage);
      formdata.append("topic_id", this.topicId);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/topic/update/${this.subtopicId}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$refs.modalsix.hide();
            this.getSubtopic(this.topicId);
            this.$swal("Success", "Subtopic updated successfully", "success");
            (this.subtopicName = ""),
              (this.subtopicDescription = ""),
              (this.subtopicImage = "");
            (this.topicEmpty = false), (this.topicDescriptionEmpty = false);
            this.topicImageEmpty = false; 
            this.subtopicImageEmpty = false
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async editTopic() {
      if (this.topicName == "") {
        this.topicEmpty = true;
        return;
      }

      if (this.topicDescription == "") {
        this.topicDescriptionEmpty = true;
        return;
      }

      if (this.topicImage == "") {
        this.topicImageEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("name", this.topicName);
      formdata.append("description", this.topicDescription);
      formdata.append("image", this.topicImage);
      formdata.append("topic_id", this.parentTopicId);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/topic/update/${this.topicId}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$refs.modalfive.hide();
            this.getTopics(this.parentTopicId);
            this.$swal("Success", "Topic updated successfully", "success");
            (this.topicName = ""),
              (this.topicDescription = ""),
              (this.topicImage = "");
            (this.topicEmpty = false), (this.topicDescriptionEmpty = false);
            this.topicImageEmpty = false;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async editParentTopic() {
      if (this.parentTopicName == "") {
        this.parentTopicEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("name", this.parentTopicName);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/topic/update/${this.parentTopicId}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$refs.modalfour.hide();
            this.getParentTopics();
            this.$swal(
              "Success",
              "Parent Topic updated successfully",
              "success"
            );
            this.parentTopicName = "";
            this.parentTopicEmpty = false;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async loadSubtopic(id) {
      this.subtopicId = id;
      await axios
        .get(`${this.$store.getters.baseUrl}/topic/edit/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.subtopicName = response.data.topic.name;
            this.subtopicDescription = response.data.topic.description;
            this.subtopicImage = response.data.topic.image;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal(
            "Error",
            error.response.data.message,
            "error"
          );
        });
    },

    async loadTopic(id) {
      this.topicId = id;
      await axios
        .get(`${this.$store.getters.baseUrl}/topic/edit/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.topicName = response.data.topic.name;
            this.topicDescription = response.data.topic.description;
            this.topicImage = response.data.topic.image;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal(
            "Error",
            error.response.data.message,
            "error"
          );
        });
    },

    async loadParentTopic(id) {
      this.parentTopicId = id;
      await axios
        .get(`${this.$store.getters.baseUrl}/topic/edit/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.parentTopicName = response.data.topic.name;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal(
            "Error",
            error.response.data.message,
            "error"
          );
        });
    },

    async addParentTopic() {
      if (this.parentTopicName == "") {
        this.parentTopicEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("name", this.parentTopicName);
      await axios
        .post(`${this.$store.getters.baseUrl}/topic/store`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$refs.modalone.hide();
            this.getParentTopics();
            this.$swal("Success", "Parent Topic added successfully", "success");
            this.parentTopicName = "";
            this.parentTopicEmpty = false;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    cancelButtonParentTopic() {
      this.$refs.modalone.hide();
      this.parentTopicEmpty = false;
      this.parentTopicName = "";
    },

    async getParentTopics() {
       this.loader = true
      await axios
        .get(`${this.$store.getters.baseUrl}/topics`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then(async(response) => {
          console.log(response);
          if(response.data.status == "success") {
            this.parentTopics = await response.data.topics;
             this.loader = false
          } else {
             this.loader = false
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
           this.loader = false
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    imageUpload(event) {
      this.topicImage = event.target.files[0];
    },

    addTopicCancelButton() {
      this.$refs.modaltwo.hide();
      (this.topicName = ""),
        (this.topicDescription = ""),
        (this.topicImage = "");
      (this.topicEmpty = false), (this.topicDescriptionEmpty = false);
      this.topicImageEmpty = false;
    },

    subtopicImageUpload(event) {
      this.subtopicImageEmpty = false
      this.subtopicImage = event.target.files[0];
    },

    async addTopic() {
      if (this.topicName == "") {
        this.topicEmpty = true;
        return;
      }

      if (this.topicDescription == "") {
        this.topicDescriptionEmpty = true;
        return;
      }

      if (this.topicImage == "") {
        this.topicImageEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("name", this.topicName);
      formdata.append("description", this.topicDescription);
      formdata.append("image", this.topicImage);
      formdata.append("topic_id", this.parentTopicId);
      await axios
        .post(`${this.$store.getters.baseUrl}/topic/store`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$refs.modaltwo.hide();
            this.getTopics(this.parentTopicId);
            this.$swal("Success", "Topic added successfully", "success");
            (this.topicName = ""),
              (this.topicDescription = ""),
              (this.topicImage = "");
            (this.topicEmpty = false), (this.topicDescriptionEmpty = false);
            this.topicImageEmpty = false;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getTopics(id, name) {
      this.topicHeader = name
      this.addTopicButton = true;
      this.parentTopicClicked = false
      this.parentTopicId = id;
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.topics = response.data.topics;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async addSubTopic() {
      if (this.subtopicName == "") {
        this.topicEmpty = true;
        return;
      }

      if (this.subtopicDescription == "") {
        this.topicDescriptionEmpty = true;
        return;
      }

      if (this.subtopicImage == "") {
        this.subtopicImageEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("name", this.subtopicName);
      formdata.append("description", this.subtopicDescription);
      formdata.append("image", this.subtopicImage);
      formdata.append("topic_id", this.topicId);
      await axios
        .post(`${this.$store.getters.baseUrl}/topic/store`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$refs.modalthree.hide();
            this.getSubtopic(this.topicId);
            this.$swal("Success", "Subtopic added successfully", "success");
            (this.subtopicName = ""),
              (this.subtopicDescription = ""),
              (this.subtopicImage = "");
            (this.topicEmpty = false), (this.topicDescriptionEmpty = false);
            this.topicImageEmpty = false;
            this.subtopicImageEmpty = false
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    cancelButtonSubtopic() {
      this.$refs.modalthree.hide();
      (this.subtopicName = ""),
        (this.subtopicDescription = ""),
        (this.subtopicImage = "");
      (this.topicEmpty = false), (this.topicDescriptionEmpty = false);
      this.topicImageEmpty = false;
    },
    async getSubtopic(id, name) {
      this.parentTopicClicked = true
      this.subtopicHeader = name
      this.addSubtopicButton = true;
      this.topicId = id;
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.subTopics = response.data.topics;
          } else {
           this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async deleteParentTopic(id) {
      await axios
        .get(`${this.$store.getters.baseUrl}/topic/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == 'success') {
          console.log(response);
          this.$swal("Success", "Parent topic deleted successfully", "success");
          this.getParentTopics();
          if (
            response.data.message ==
            "This topic has subtopics. Please delete those first"
          ) {
            this.$swal(
              "Error",
              "Please delete the topics and subtopics before deleting the parent topics",
              "warning"
            );
          }
        }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async deleteTopic(id) {
      await axios
        .get(`${this.$store.getters.baseUrl}/topic/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if(response.data.status == 'success') {
          console.log(response);
          this.getTopics(this.parentTopicId);
          this.$swal("Success", "Topic deleted successfully", "success");
          if (
            response.data.message ==
            "This topic has subtopics. Please delete those first"
          ) {
            this.$swal(
              "Error",
              "Please delete subtopics before deleting the topic",
              "warning"
            );
          }
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async deleteSubtopic(id) {
      await axios
        .get(`${this.$store.getters.baseUrl}/topic/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if(response.data.status == 'success') {
          console.log(response);
          this.getSubtopic(this.topicId);
          this.$swal("Success", "Subtopic deleted successfully", "success");
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    cancelButtonEditParentTopic() {
      this.$refs.modalfour.hide();
      this.parentTopicEmpty = false;
      this.parentTopicName = "";
    },
    cancelButtonEditTopic() {
      this.$refs.modalfive.hide();
      this.topicName = "";
      this.topicDescription = "";
      this.topicImage = "";
      this.topicEmpty = false;
      this.topicDescriptionEmpty = false;
      this.topicImageEmpty = false;
    },
    cancelButtonEditSubtopic() {
      this.$refs.modalsix.hide();
      this.subtopicName = "";
      this.subtopicDescription = "";
      this.subtopicImage = "";
      this.topicEmpty = false;
      this.topicDescriptionEmpty = false;
      this.topicImageEmpty = false;
    },
  },
};
</script>

<style scoped>
.level1 ::-webkit-scrollbar {
  width: 0px;
  background: transparent; /* make scrollbar transparent */
} 

.level2 ::-webkit-scrollbar {
  width: 0px;
  background: transparent; /* make scrollbar transparent */
}

.level3 ::-webkit-scrollbar {
  width: 0px;
  background: transparent; /* make scrollbar transparent */
}

Button:focus {
  outline: none;
}

#addParentTopicButton {
  background-color: #e1e6e9;
}

#addTopicButton {
  background-color: #e1e6e9;
}

#addSubTopicButton {
  background-color: #e1e6e9;
}
</style>